import { useTranslation } from 'react-i18next';
import { CustomSelect } from 'libs/ui';

export const PrioritySelect = (props) => {
  const { t } = useTranslation();
  const { value, change, ...rest } = props;

  const items = [
    { name: t('filters.Все'), value: '' },
    { name: t('clarifications.Высокий'), value: 'critical' },
    { name: t('clarifications.Средний'), value: 'notification' },
    { name: t('clarifications.Низкий'), value: 'info' },
  ];

  return <CustomSelect className="priority" value={value} onChange={change} items={items} {...rest} />;
};
